import Button from "@mui/material/Button";
import DialogContent from "@mui/material/DialogContent";
import React from "react";

import { ErrorSeverity, useErrorHandler } from "../../hooks/useErrorHandler";
import { FORBIDDEN_VIDEO_ERROR_MESSAGE } from "../../util/constants";
import {
  ButtonContainer,
  HelpLink,
  IconContainer,
  Message,
  StyledBlockedIcon,
  StyledDialog,
  Title,
} from "./ForbiddenVideoModal.elements";

const getErrorReferenceId = (error?: string) => {
  if (!error?.endsWith(")")) {
    return undefined;
  }

  const referenceStartIndex = error.lastIndexOf("(");
  if (referenceStartIndex === -1) {
    return undefined;
  }

  return error.slice(referenceStartIndex + 1, -1);
};

export function ForbiddenVideoModal(): React.ReactElement | null {
  const { error } = useErrorHandler(ErrorSeverity.MEDIUM);

  const isVideoForbidden = typeof error === "string" && error.includes(FORBIDDEN_VIDEO_ERROR_MESSAGE);
  const errorReferenceId = typeof error === "string" ? getErrorReferenceId(error) : undefined;
  const supportReferenceId = errorReferenceId && !/^\d+$/.test(errorReferenceId) ? errorReferenceId : undefined;

  if (!isVideoForbidden) {
    return null;
  }

  const handleReturnToLibrary = () => {
    window.location.href = "/";
  };

  return (
    <StyledDialog open={isVideoForbidden} disableEscapeKeyDown>
      <DialogContent sx={{ padding: 0 }}>
        <IconContainer>
          <StyledBlockedIcon />
        </IconContainer>

        <Title variant="h5">Video Playback Blocked</Title>

        <Message variant="body1">
          Video playback is blocked by local network settings; contact your local support for assistance. For more
          information about SANS technical requirements contact{" "}
          <HelpLink href="mailto:ondemand@sans.org">ondemand@sans.org</HelpLink>.
        </Message>
        {supportReferenceId ? <Message variant="body2">Reference ID: {supportReferenceId}</Message> : null}

        <ButtonContainer>
          <Button variant="contained" color="primary" onClick={handleReturnToLibrary}>
            Return to Library
          </Button>
        </ButtonContainer>
      </DialogContent>
    </StyledDialog>
  );
}
